// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Image_imageWrapper__eSKGe","left":"Image_left__JsDQw","right":"Image_right__FBUMI","image":"Image_image__moDvP"};